webpackJsonp([35783957827783],{

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Fade(e,t){function o(e){function t(){var t=p||u||i||a||l||s,o=void 0,r=void 0;if(t){var d=n?"2000px":"100%",f=_&&e;o=p?(f?"":"-")+d:u?(f?"-":"")+d:"0",r=a||l?(f?"":"-")+d:i||s?(f?"-":"")+d:"0"}return(0,_globals.animation)((e?"to":"from")+" {opacity: 0;"+(t?" transform: translate3d("+o+", "+r+", 0);":"")+"}\n         "+(e?"from":"to")+" {opacity: 1;transform: none;} ")}return{reverse:p,make:t}}var r=e.out,p=e.left,u=e.right,i=e.up,a=e.down,l=e.top,s=e.bottom,n=e.big,_=e.opposite,d=(0,_objectWithoutProperties3.default)(e,["out","left","right","up","down","top","bottom","big","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},d,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(60),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(81),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(3),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(101),_Reveal=__webpack_require__(99),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(100),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Fade.propTypes=propTypes,Fade.defaultProps=defaultProps,exports.default=Fade,module.exports=exports.default;

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Flip(e,t){function n(e){function t(){var t=void 0;if(s||u||r||p||i||a){var n=e&&l,o=s||i||a?(a?n?"":"-":n?"-":"")+"1":"0",f=u||p||r?(r?n?"":"-":n?"-":"")+"1":"0";t=e?"from {\n              transform: perspective(400px);\n            }\n\n            30% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -15deg);\n              opacity: 1;\n            }\n\n            to {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              opacity: 0;\n            }":"from {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              animation-timing-function: ease-in;\n              opacity: 0;\n            }\n\n            40% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -20deg);\n              animation-timing-function: ease-in;\n            }\n\n            60% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 10deg);\n              opacity: 1;\n            }\n\n            80% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -5deg);\n            }\n\n            to {\n              transform: perspective(400px);\n            }"}else t="from {\n              transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n              animation-timing-function: ease-out;\n              opacity: "+(e?"1":"0")+";\n            }\n\n            40% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n              animation-timing-function: ease-out;\n            }\n\n            50% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n              animation-timing-function: ease-in;\n            }\n\n            to {\n              transform: perspective(400px);\n              animation-timing-function: ease-in;\n              opacity: "+(e?"0":"1")+";\n            }";return(0,_globals.animation)(t)}return{style:{backfaceVisibility:"visible"},make:t}}var o=e.out,r=e.left,p=e.right,i=e.top,a=e.bottom,s=e.x,u=e.y,l=e.opposite,f=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","x","y","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},f,{in:n(!1),out:n(!0)})):n(o)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(60),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(81),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(3),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(101),_Reveal=__webpack_require__(99),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(100),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Flip.propTypes=propTypes,Flip.defaultProps=defaultProps,exports.default=Flip,module.exports=exports.default;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(60),_extends3=_interopRequireDefault(_extends2),_getPrototypeOf=__webpack_require__(585),_getPrototypeOf2=_interopRequireDefault(_getPrototypeOf),_classCallCheck2=__webpack_require__(59),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(225),_createClass3=_interopRequireDefault(_createClass2),_possibleConstructorReturn2=__webpack_require__(112),_possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2),_inherits2=__webpack_require__(111),_inherits3=_interopRequireDefault(_inherits2),_react=__webpack_require__(3),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(101),_globals=__webpack_require__(100),_Step=__webpack_require__(1300),_Step2=_interopRequireDefault(_Step),_debounce=__webpack_require__(1302),_debounce2=_interopRequireDefault(_debounce),propTypes={when:_propTypes.bool,spy:_propTypes.any,effect:_propTypes.string,collapse:(0,_propTypes.oneOfType)([_propTypes.bool,_propTypes.string]),duration:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool,tag:_propTypes.string,step:(0,_propTypes.oneOfType)([(0,_propTypes.instanceOf)(_Step2.default),_propTypes.string]),className:_propTypes.string,style:_propTypes.object,props:_propTypes.object,force:_propTypes.bool,bypass:_propTypes.bool,fraction:_propTypes.number,onReveal:_propTypes.func,children:_propTypes.node.isRequired,in:_propTypes.object,out:(0,_propTypes.oneOfType)([_propTypes.object,_propTypes.bool])},defaultProps={duration:1e3,delay:0,count:1,fraction:.2,tag:"div",when:!0},contextTypes={stepper:_propTypes.object},RevealBase=function(e){function t(e){(0,_classCallCheck3.default)(this,t);var s=(0,_possibleConstructorReturn3.default)(this,(t.__proto__||(0,_getPrototypeOf2.default)(t)).call(this,e));return s.state={legacyMode:!1,style:{height:e.collapse?0:void 0,visibility:e.collapse?e.when||!e.out?"visible":"hidden":void 0,opacity:!e.when&&e.out?0:void 0}},s.isListener=!1,s.isShown=!!s.props.bypass,s.revealHandler=(0,_debounce2.default)(s.reveal.bind(s,!1),66),s.resizeHandler=(0,_debounce2.default)(s.resize.bind(s),500),s.invisible=(0,_debounce2.default)(s.invisible,500),s.saveRef=function(e){return s.el=e},s}return(0,_inherits3.default)(t,e),(0,_createClass3.default)(t,[{key:"inViewport",value:function(){if(!this.el||window.document.hidden)return!1;var e=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),i=Math.min(e,window.innerHeight)*(_globals.globalHide?this.props.fraction:0);return s>i-window.innerHeight&&s<e-i}},{key:"hide",value:function(){this.props.out&&this.setState({style:{opacity:0}})}},{key:"resize",value:function(){this&&this.el&&this.props.when&&this.inViewport()&&(this.clean(),this.isShown=!!this.props.when,this.setState({style:{opacity:this.props.when||!this.props.out?1:0}}),this.props.onReveal&&this.props.when&&this.props.onReveal())}},{key:"invisible",value:function(){this&&!this.isShown&&this.setState({style:(0,_extends3.default)({},this.state.style,{visibility:"hidden"})})}},{key:"animationEnd",value:function(e,t){var s=this;if(!t){var i=this.finalEl||this.el,n=function t(){s&&i&&(i.removeEventListener("animationend",t),e.call(s))};i.addEventListener("animationend",n)}}},{key:"collapse",value:function(e,t){if(t.collapse&&t.out){var s=t.duration+(t.cascade?!0===t.cascade?1e3:t.cascade:0),i=s>>2,n=t.when?i:s-i,o=t.delay+(t.when?0:i);return(0,_extends3.default)({},e,{height:t.when?!0===t.collapse?this.dummyEl.offsetHeight:t.collapse:0,transition:"height "+n+"ms ease "+o+"ms"})}return e}},{key:"animate",value:function(e){if(this&&this.el){if(this.clean(),e.effect)this.setState({legacyMode:!0});else{var t=e[e.when||!e.out?"in":"out"],s=e.out||e.when?t.animation||t.make():void 0;if(this.isShown===!!e.when)return;this.isShown=!!e.when,this.setState({style:this.collapse((0,_extends3.default)({animationName:s,animationDuration:e.duration+"ms",animationDelay:e.delay+"ms",animationIterationCount:e.forever?"infinite":e.count,animationFillMode:"both",opacity:1},t.style),e)}),!e.when&&e.out&&this.animationEnd(this.invisible,e.forever)}e.onReveal&&e.when&&e.onReveal()}}},{key:"clean",value:function(){this.isListener&&(window.removeEventListener("scroll",this.revealHandler),window.removeEventListener("orientationchange",this.revealHandler),window.document.removeEventListener("visibilitychange",this.revealHandler),window.removeEventListener("resize",this.resizeHandler),this.isListener=!1)}},{key:"componentWillUnmount",value:function(){this.clean(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"listen",value:function(){this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler),window.addEventListener("orientationchange",this.revealHandler),window.document.addEventListener("visibilitychange",this.revealHandler),window.addEventListener("resize",this.resizeHandler))}},{key:"reveal",value:function(e){var t=this;if(this&&this.el)if(e||(e=this.props),this.inViewport()){if(this.start)return this.hide(),this.listen(),void this.start(this.step);e.when&&this.isShown&&"spy"in e?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.animate.call(t,e)},200)):this.animate(e)}else this.listen()}},{key:"componentDidMount",value:function(){if(this.el&&!this.props.bypass){if(this.props.force)return this.animate(this.props);this.props.step instanceof _Step2.default?this.props.step.push(this):this.props.step&&this.context.stepper&&this.context.stepper.get(this.props.step).push(this),_globals.ssr&&(this.props.out||this.props.effect)&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms"}}),window.setTimeout(this.revealHandler,1e3)):this.props.when&&this.reveal(this.props)}}},{key:"cascade",value:function(e){var t=this,s=void 0;s="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var i=s.length-1,n=this.props.duration+(!0===this.props.cascade?1e3:this.props.cascade),o=0;return s=s.map(function(e){return _react2.default.cloneElement(e,{style:(0,_extends3.default)({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(o++,0,i,t.props.duration,n))+"ms"}),ref:o===i?function(e){return t.finalEl=e}:void 0})})}},{key:"componentWillReceiveProps",value:function(e){e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e)}},{key:"dummy",value:function(e){var t=this;if(!0!==this.props.collapse)return e;var s=[e,_react2.default.createElement(e.type,(0,_extends3.default)({},this.props.props||void 0,{className:this.props.className,children:this.props.children,key:2,ref:function(e){return t.dummyEl=e},style:(0,_extends3.default)({},this.props.style,{position:"absolute",left:"-9999em",top:"-9999em",height:"auto",display:"block",animationName:"none",animationDuration:"0s",transition:"none",opacity:0})}))];return _react2.default.createElement("span",null,s)}},{key:"render",value:function(){var e=this.props,t=e.tag,s=e.id,i=e.children,n=e.style,o=e.className,r=(this.state.legacyMode?this.props.effect:this.props.out||this.props.effect?_globals.namespace:"")+(o?" "+o:"")||void 0,a=void 0,p=!1;this.state.legacyMode||(a=(0,_extends3.default)({},n,this.state.style),this.props.cascade&&i&&this.state.style.animationName&&(p=this.cascade(i),a.animationName=void 0));var l=_react2.default.createElement(t,(0,_extends3.default)({},this.props.props||void 0,{id:s,className:r,style:this.state.legacyMode?n:a,key:this.props.collapse?1:void 0,ref:this.saveRef}),p||i);return this.props.collapse?this.dummy(l):l}}],[{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,exports.default=RevealBase,module.exports=exports.default;

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Rotate(e,t){function o(e){function t(){var t="-200deg",o="center";return e&&n?((l||a)&&u&&(t="-45deg"),((l||a)&&p||(s||i)&&u)&&(t="45deg"),(s||i)&&p&&(t="-90deg"),(p||u)&&(o=(u?"left":"right")+" bottom")):((s||i)&&p&&(t="-45deg"),((s||i)&&u||(l||a)&&p)&&(t="45deg"),(l||a)&&u&&(t="-90deg"),(p||u)&&(o=(p?"left":"right")+" bottom")),(0,_globals.animation)("\n        "+(e?"to":"from")+" { opacity: 0; transform-origin: "+o+"; transform: rotate3d(0, 0, 1, "+t+");}\n        "+(e?"from":"to")+" { opacity: 1; transform-origin: "+o+"; transform: none;}\n      ")}return{make:t}}var r=e.out,p=e.left,u=e.right,i=e.top,a=e.bottom,l=e.up,s=e.down,n=e.opposite,_=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},_,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(60),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(81),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(3),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(101),_Reveal=__webpack_require__(99),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(100),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Rotate.propTypes=propTypes,Rotate.defaultProps=defaultProps,exports.default=Rotate,module.exports=exports.default;

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _classCallCheck2=__webpack_require__(59),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(225),_createClass3=_interopRequireDefault(_createClass2),Step=function(){function e(t){var s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e3;(0,_classCallCheck3.default)(this,e),this.after=s,this.name=t,this.chain=[]}return(0,_createClass3.default)(e,[{key:"push",value:function(e){this.start&&(e.step=this.index,e.start=this.start),this.chain.push(e)}}]),e}();exports.default=Step,module.exports=exports.default;

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Zoom(e,t){function o(e){function t(){var t=p||n,o=i||a||s||u,r=t||o,c=void 0,f=void 0,d=void 0,_=void 0,m=void 0;return r?e?(f=t?((l?n:p)?"":"-")+"42px":"0",d=o?((l?s||a:u||i)?"-":"")+"60px":"0",_=t?((l?p:n)?"":"-")+"2000px":"0",m=o?((l?u||i:s||a)?"":"-")+"2000px":"0",c="40% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+f+", "+d+", 0);\n            }\n            to {\n              opacity: 0;\n              transform: scale(.1) translate3d("+_+", "+m+", 0);\n              transform-origin: "+(o?"center bottom":((l?n:p)?"left":"right")+" center")+";\n            }"):(f=t?(p?"-":"")+"1000px":"0",d=o?(u||i?"-":"")+"1000px":"0",_=t?(n?"-":"")+"10px":"0",m=o?(s||a?"-":"")+"60px":"0",c="from {\n              opacity: 0;\n              transform: scale3d(.1, .1, .1) translate3d("+f+", "+d+", 0);\n              animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n            }\n            60% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+_+", "+m+", 0);\n              animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n            }"):c=(e?"to":"from")+" {opacity: 0; transform: scale3d(.1, .1, .1);} "+(e?"from":"to")+" { opacity: 1; transform: none;}",(0,_globals.animation)(c)}return{make:t}}var r=e.out,p=e.left,n=e.right,i=e.top,a=e.bottom,s=e.up,u=e.down,l=e.opposite,c=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},c,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(60),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(81),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(3),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(101),_Reveal=__webpack_require__(99),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(100),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Zoom.propTypes=propTypes,Zoom.defaultProps=defaultProps,exports.default=Zoom,module.exports=exports.default;

/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

	"use strict";function debounce(e,t,u){var o;return function(){var r=this,n=arguments,l=function(){o=null,u||e.apply(r,n)},p=u&&!o;clearTimeout(o),o=setTimeout(l,t),p&&e.apply(r,n)}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=debounce,module.exports=exports.default;

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	"use strict";function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,i,o){var r=Math.log(i),s=Math.log(o),a=(s-r)/(t-n);return Math.exp(r+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll),exports.globalHide=globalHide=!0}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation;var namespace=exports.namespace="react-reveal",is16=exports.is16=!1,ssr=exports.ssr=!0,disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},globalHide=exports.globalHide=!1,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<500&&(exports.ssr=ssr=!1);var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _Reveal=__webpack_require__(99);Object.defineProperty(exports,"default",{enumerable:!0,get:function(){return _interopRequireDefault(_Reveal).default}});var _Fade=__webpack_require__(1297);Object.defineProperty(exports,"Fade",{enumerable:!0,get:function(){return _interopRequireDefault(_Fade).default}});var _Flip=__webpack_require__(1298);Object.defineProperty(exports,"Flip",{enumerable:!0,get:function(){return _interopRequireDefault(_Flip).default}});var _Rotate=__webpack_require__(1299);Object.defineProperty(exports,"Rotate",{enumerable:!0,get:function(){return _interopRequireDefault(_Rotate).default}});var _Zoom=__webpack_require__(1301);Object.defineProperty(exports,"Zoom",{enumerable:!0,get:function(){return _interopRequireDefault(_Zoom).default}});

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-image: url(\'', '\');\n    background-size: contain;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    padding: 120px 0 200px;\n  '], ['\n    background-image: url(\'', '\');\n    background-size: contain;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    padding: 120px 0 200px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n  '], ['\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: calc((100% / 3) - (80px / 3));\n  '], ['\n    width: calc((100% / 3) - (80px / 3));\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      margin: 40px 40px 0 0;\n    '], ['\n      margin: 40px 40px 0 0;\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      margin: 0 40px 0 0;\n    '], ['\n      margin: 0 40px 0 0;\n    ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n      margin: 80px 0 0;\n    '], ['\n      margin: 80px 0 0;\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n      max-width: 100px;\n    '], ['\n      max-width: 100px;\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n      max-width: none;\n    '], ['\n      max-width: none;\n    ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    padding-bottom: 160px;\n    ', ';\n    ', '\n  '], ['\n    padding-bottom: 160px;\n    ', ';\n    ', '\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _NorthAmericaMap = __webpack_require__(1513);
	
	var _NorthAmericaMap2 = _interopRequireDefault(_NorthAmericaMap);
	
	var _HowardThomas = __webpack_require__(1512);
	
	var _HowardThomas2 = _interopRequireDefault(_HowardThomas);
	
	var _ShaoYang = __webpack_require__(1514);
	
	var _ShaoYang2 = _interopRequireDefault(_ShaoYang);
	
	var _biobelleLogo = __webpack_require__(1515);
	
	var _biobelleLogo2 = _interopRequireDefault(_biobelleLogo);
	
	var _shared = __webpack_require__(7);
	
	var _components = __webpack_require__(418);
	
	var _FacebookTags = __webpack_require__(108);
	
	var _FacebookTags2 = _interopRequireDefault(_FacebookTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var colors = _styles.theme.colors,
	    sp = _styles.theme.sp;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__Wrapper'
	})(['width:100%;overflow:hidden;']);
	
	var TestimonialsWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialsWrapper'
	})(['margin-top:', ';padding:60px 0 0;', ';'], sp.l, _styles.media.tablet(_templateObject, function (props) {
	  return props.src;
	}));
	
	var TestimonialsHeadings = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialsHeadings'
	})(['text-align:center;margin:0 auto 100px;max-width:600px;h3{font-size:36px;line-height:42px;margin-bottom:', ';}h4{font-size:18px;line-height:23px;}'], sp.l);
	
	var TestimonialsGrid = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialsGrid'
	})(['', ';'], _styles.media.tablet(_templateObject2));
	
	// prettier-ignore
	var TestimonialsItem = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialsItem'
	})(['margin:0 0 40px;border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,0.1);color:', ';', ';&:nth-child(1){background-color:', ';', ';}&:nth-child(2){background-color:', ';', ';}&:nth-child(3){background-color:', ';', ';}'], colors.white, _styles.media.tablet(_templateObject3), colors.blue, _styles.media.tablet(_templateObject4), colors.navy, _styles.media.tablet(_templateObject5), colors.royal, _styles.media.tablet(_templateObject6));
	
	var TestimonialContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialContent'
	})(['padding:30px 30px 80px;']);
	
	var TestimonialMeta = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialMeta'
	})(['position:relative;text-align:right;padding:30px;background-color:', ';color:', ';h3{display:inline-block;font-size:16px;line-height:18px;font-weight:700;margin-bottom:', ';', ';', ';}h4{font-size:16px;line-height:18px;font-weight:500;}'], colors.white, colors.greyDark, sp.s, _styles.media.tablet(_templateObject7), _styles.media.desktop(_templateObject8));
	
	var TestimonialImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__TestimonialImage'
	})(['position:absolute;top:-50px;left:30px;width:100px;height:100px;background-color:', ';border:4px solid ', ';border-radius:50%;img{max-width:100%;border-radius:50%;}'], colors.mustard, colors.white);
	
	// prettier-ignore
	var Section = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__Section'
	})(['padding:90px 0 100px;background:', ';', ';', ' ', ''], colors.grey, function (props) {
	  return props.bg && 'background: ' + colors[props.bg] + ';';
	}, _styles.media.laptop(_templateObject9, function (props) {
	  return props.floaters && 'padding-bottom: 0;';
	}, function (props) {
	  return props.initial && '\n      padding-bottom: 0px;\n    ';
	}), function (props) {
	  return props.floaters && '\n    position: relative;\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 0;\n    background: none;\n    overflow: visible;\n  ';
	});
	
	var CaseStudiesHeadings = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'HomePage__CaseStudiesHeadings'
	})(['text-align:center;margin:0 auto 100px;max-width:600px;h3{font-size:36px;line-height:42px;margin-bottom:', ';}h4{font-size:18px;line-height:23px;}'], sp.l);
	
	var propTypes = {
	  data: _propTypes2.default.shape({ contentfulHomepage: _propTypes2.default.object }).isRequired
	};
	
	function HomePage(_ref) {
	  var data = _ref.data;
	
	  var homepage = data.contentfulHomepage;
	  var caseStudyNodes = data.allContentfulCaseStudy;
	  var seoTitle = homepage.seoTitle,
	      seoKeywords = homepage.seoKeywords,
	      seoDescription = homepage.seoDescription;
	
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: seoTitle,
	      keywords: seoKeywords,
	      description: seoDescription && seoDescription.seoDescription
	    }),
	    _react2.default.createElement(_FacebookTags2.default, {
	      fbUrl: ("https://markettap.com") + '/',
	      fbTitle: seoTitle,
	      fbDescription: seoDescription && seoDescription.seoDescription,
	      fbImage: 'http:' + homepage.heroImage.fullSize.src
	    }),
	    _react2.default.createElement(
	      Section,
	      { bg: 'offWhite', initial: true },
	      _react2.default.createElement(_components.Hero, {
	        heading: homepage.heroHeading,
	        image: homepage.heroImage,
	        buttonText: homepage.heroButtonText,
	        textLines: homepage.heroTypingValues
	      })
	    ),
	    _react2.default.createElement(
	      Section,
	      { bg: 'white' },
	      _react2.default.createElement(_components.VideoCallout, {
	        heading: homepage.videoHeading,
	        subheading: homepage.videoSubheading,
	        buttonText: homepage.videoButtonText,
	        videoThumbnail: homepage.videoThumbnail
	      })
	    ),
	    _react2.default.createElement(
	      Section,
	      { floaters: true },
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(_shared.Floater, { img: 'coffee', ratio: 0.07 })
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      { bg: 'white' },
	      _react2.default.createElement(_components.ServiceDetails, { details: homepage.serviceDetails })
	    ),
	    _react2.default.createElement(
	      Section,
	      { bg: 'blueIce' },
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          CaseStudiesHeadings,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            homepage.caseStudyHeading
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            homepage.caseStudySubheading
	          )
	        ),
	        _react2.default.createElement(_shared.SwipeableCaseStudies, { nodes: caseStudyNodes })
	      ),
	      _react2.default.createElement(
	        TestimonialsWrapper,
	        { src: _NorthAmericaMap2.default },
	        _react2.default.createElement(
	          _shared.Container,
	          null,
	          _react2.default.createElement(
	            TestimonialsHeadings,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'We work with awesome brands across North America.'
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'See what they\u2019re saying about us.'
	            )
	          ),
	          _react2.default.createElement(
	            TestimonialsGrid,
	            null,
	            _react2.default.createElement(
	              TestimonialsItem,
	              null,
	              _react2.default.createElement(
	                TestimonialContent,
	                null,
	                'MarketTap has all of the attributes you need to work successfully these days \u2013 they "get" new marketing and media paradigms and have a unique ability to blend the science of media with arts to generate thoughtful results. The great thing about Market Tap is not only their high level of responsiveness but more important, a real sense of pro-activity they bring to the relationship. It\'s great to work with a team that gets ahead of the curve on a daily basis and has a service orientation that is not just about being fast, but adding value every day.'
	              ),
	              _react2.default.createElement(
	                TestimonialMeta,
	                null,
	                _react2.default.createElement(
	                  TestimonialImage,
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _HowardThomas2.default,
	                    alt: 'Howard Thomas, CMO, U-Feast Corporation'
	                  })
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Howard Thomas'
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'CMO, U-Feast Corporation'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              TestimonialsItem,
	              null,
	              _react2.default.createElement(
	                TestimonialContent,
	                null,
	                'MarketTap handles our SEO. We were absolutely thrilled to see a 22% increase in website visitors in the first month of the program. January is usually a really slow month for us, but we were jammed with appointments made through our website. This proved the importance of SEO and that MarketTap\'s services really work.'
	              ),
	              _react2.default.createElement(
	                TestimonialMeta,
	                null,
	                _react2.default.createElement(
	                  TestimonialImage,
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _ShaoYang2.default,
	                    alt: 'Shao Yang, Founder, The Tailory New York'
	                  })
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Shao Yang'
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Founder, The Tailory New York'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              TestimonialsItem,
	              null,
	              _react2.default.createElement(
	                TestimonialContent,
	                null,
	                'MarketTap\'s a la carte service model is so impressive. They have helped us double our online sales with Facebook Advertising and contests. Overtime, we began to outsource other activities we find time consuming, like writing product descriptions, creating newsletters, and monitoring our Google Analytics. They are fast, smart, and really reliable.'
	              ),
	              _react2.default.createElement(
	                TestimonialMeta,
	                null,
	                _react2.default.createElement(
	                  TestimonialImage,
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _biobelleLogo2.default,
	                    alt: 'Forty Amsel, CEO, Biobelle Cosmetics'
	                  })
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Forty Amsel'
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'CEO, Biobelle Cosmetics'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	HomePage.propTypes = propTypes;
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(14);
	
	var _styles = __webpack_require__(6);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroContainer = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'Hero__HeroContainer'
	})(['position:relative;padding:0 15px;']);
	
	var HeroButton = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Button).withConfig({
	  displayName: 'Hero__HeroButton'
	})(['margin-bottom:', ';'], _theme.sp.max);
	
	var HeroImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Hero__HeroImage'
	})(['display:block;width:100%;height:auto;margin-bottom:-200px;img{max-width:100%;}', ';'], _styles.media.tablet(_templateObject));
	
	var propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  buttonText: _propTypes2.default.string.isRequired,
	  textLines: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  image: _propTypes2.default.shape({
	    fullSize: _propTypes2.default.object,
	    thumbnail: _propTypes2.default.object
	  }).isRequired
	};
	
	function Hero(_ref) {
	  var heading = _ref.heading,
	      buttonText = _ref.buttonText,
	      textLines = _ref.textLines,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    HeroContainer,
	    { centerText: true },
	    _react2.default.createElement(_shared.TypingHero, { heading: heading, lines: textLines }),
	    _react2.default.createElement(
	      HeroButton,
	      { blue: true, to: '/services' },
	      buttonText
	    ),
	    _react2.default.createElement(
	      HeroImage,
	      null,
	      _react2.default.createElement('img', { src: image.fullSize.src, alt: 'MarketTap' })
	    )
	  );
	}
	
	Hero.propTypes = propTypes;
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(408);
	
	var _Hero2 = _interopRequireDefault(_Hero);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Hero2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  '], ['\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    order: inherit;\n'], ['\n    order: inherit;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    order: inherit;\n  '], ['\n    order: inherit;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      padding: 0 0 0 30px;\n    '], ['\n      padding: 0 0 0 30px;\n    ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__(132);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _shared = __webpack_require__(7);
	
	var _styles = __webpack_require__(6);
	
	var _theme = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propTypes = {
	  detail: _propTypes2.default.arrayOf({}).isRequired,
	  rightImage: _propTypes2.default.bool.isRequired
	};
	
	var StyledContainer = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'Detail__StyledContainer'
	})(['img{padding-right:', ';}&:nth-child(odd){img{padding-right:0;padding-left:', ';}}'], _theme.sp.l, _theme.sp.l);
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Detail__Wrapper'
	})(['display:flex;flex-direction:column;margin-bottom:', ';', ';'], _theme.sp.xxl, _styles.media.tablet(_templateObject));
	
	var ImageWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Detail__ImageWrapper'
	})(['order:1;', ';img{width:100%;max-width:500px;}'], _styles.media.tablet(_templateObject2));
	
	var ContentWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Detail__ContentWrapper'
	})(['order:2;', ';'], _styles.media.tablet(_templateObject3));
	
	var Header = /*#__PURE__*/_styledComponents2.default.h3.withConfig({
	  displayName: 'Detail__Header'
	})(['font-size:2em;']);
	
	var List = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Detail__List'
	})(['p,ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';}ol,ul{padding:0;font-size:20px;', ';}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}'], _theme.sp.xxl, _styles.media.tablet(_templateObject4), _theme.sp.s, _theme.colors.blue, _theme.sp.s, _theme.colors.blue);
	
	function Detail(_ref) {
	  var detail = _ref.detail,
	      rightImage = _ref.rightImage;
	
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    _react2.default.createElement(
	      Wrapper,
	      null,
	      !rightImage && _react2.default.createElement(
	        ImageWrapper,
	        null,
	        _react2.default.createElement('img', { src: detail.sideImage.fullSize.src, alt: 'service' })
	      ),
	      _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	          Header,
	          null,
	          detail.headingText
	        ),
	        _react2.default.createElement(
	          List,
	          null,
	          _react2.default.createElement(_reactMarkdown2.default, {
	            source: detail.bodyText.bodyText,
	            escapeHtml: false
	          })
	        ),
	        _react2.default.createElement(
	          _shared.Button,
	          { yellow: true, to: detail.ctaLink },
	          detail.ctaText
	        )
	      ),
	      rightImage && _react2.default.createElement(
	        ImageWrapper,
	        null,
	        _react2.default.createElement('img', { src: detail.sideImage.fullSize.src, alt: 'service' })
	      )
	    )
	  );
	}
	
	Detail.propTypes = propTypes;
	
	exports.default = Detail;
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Detail = __webpack_require__(410);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  details: _propTypes2.default.arrayOf({}).isRequired
	};
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ServiceDetails__Wrapper'
	})(['']);
	
	function ServiceDetails(_ref) {
	  var details = _ref.details;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    !!details && details.map(function (d, i) {
	      return _react2.default.createElement(_Detail2.default, { rightImage: i % 2 === 0, detail: d });
	    })
	  );
	}
	
	ServiceDetails.propTypes = propTypes;
	
	exports.default = ServiceDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ServiceDetails = __webpack_require__(411);
	
	var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ServiceDetails2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-align: flex-start;\n    justify-content: space-between;\n  '], ['\n    display: flex;\n    flex-align: flex-start;\n    justify-content: space-between;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin-bottom: 0;\n      border-bottom: 0;\n      padding-bottom: 0;\n    '], ['\n      margin-bottom: 0;\n      border-bottom: 0;\n      padding-bottom: 0;\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    max-width: calc((100% - 64px) / 2);\n  '], ['\n    max-width: calc((100% - 64px) / 2);\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    max-width: 460px;\n  '], ['\n    max-width: 460px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: block;\n  '], ['\n    display: block;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactReveal = __webpack_require__(1303);
	
	var _shared = __webpack_require__(7);
	
	var _types = __webpack_require__(20);
	
	var _styles = __webpack_require__(6);
	
	var _Testimonial = __webpack_require__(414);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'Testimonials__Wrapper'
	})(['position:relative;margin-top:96px;', ';'], _styles.media.laptop(_templateObject));
	
	var TestimonialWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonials__TestimonialWrapper'
	})(['&:first-child{margin-bottom:', ';border-bottom:1px solid ', ';padding-bottom:', ';', ';}', ';', ';'], _styles.theme.sp.xxl, _styles.theme.colors.border, _styles.theme.sp.xxl, _styles.media.laptop(_templateObject2), _styles.media.laptop(_templateObject3), _styles.media.max(_templateObject4));
	
	var Divider = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonials__Divider'
	})(['display:none;position:absolute;top:100px;left:calc(50% - 0.5px);height:80%;min-height:200px;width:1px;background-color:', ';', ';'], _styles.theme.colors.border, _styles.media.laptop(_templateObject5));
	
	var propTypes = {
	  testimonials: _propTypes2.default.arrayOf(_types.TestimonialType).isRequired
	};
	
	function Testimonials(_ref) {
	  var testimonials = _ref.testimonials;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    testimonials.map(function (testimonial) {
	      return _react2.default.createElement(
	        TestimonialWrapper,
	        { key: testimonial.id },
	        _react2.default.createElement(
	          _reactReveal.Fade,
	          null,
	          _react2.default.createElement(_Testimonial2.default, { testimonial: testimonial })
	        )
	      );
	    }),
	    _react2.default.createElement(Divider, null)
	  );
	}
	
	Testimonials.propTypes = propTypes;
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-top: 110px;\n    padding-left: 100px;\n  '], ['\n    padding-top: 110px;\n    padding-left: 100px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 135px;\n    height: 135px;\n  '], ['\n    width: 135px;\n    height: 135px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _types = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Wrapper'
	})(['position:relative;padding-top:80px;padding-left:50px;', ';'], _styles.media.tablet(_templateObject));
	
	var Logo = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Logo'
	})(['position:absolute;top:0;left:0;z-index:0;background-image:url(\'', '\');background-size:contain;background-position:50% 50%;background-repeat:no-repeat;width:90px;height:90px;', ';'], function (props) {
	  return props.imageUrl;
	}, _styles.media.tablet(_templateObject2));
	
	// prettier-ignore
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Content'
	})(['', ' position:relative;z-index:1;margin-bottom:', ';color:', ';'], _styles.mixins.paragraphText, _styles.theme.sp.m, _styles.theme.colors.navy);
	
	// prettier-ignore
	var Name = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Name'
	})(['', ' color:', ';'], _styles.mixins.paragraphText, _styles.theme.colors.royal);
	
	// prettier-ignore
	var Position = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Position'
	})(['', ' color:', ';'], _styles.mixins.paragraphText, _styles.theme.colors.grey);
	
	var propTypes = {
	  testimonial: _types.TestimonialType.isRequired
	};
	
	function Testimonial(_ref) {
	  var testimonial = _ref.testimonial;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Logo, { imageUrl: testimonial.logo.fullSize.src }),
	    _react2.default.createElement(
	      Content,
	      null,
	      testimonial.testimonial.text
	    ),
	    _react2.default.createElement(
	      Name,
	      null,
	      testimonial.name
	    ),
	    _react2.default.createElement(
	      Position,
	      null,
	      testimonial.position
	    )
	  );
	}
	
	Testimonial.propTypes = propTypes;
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Testimonials = __webpack_require__(413);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Testimonials2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _mixins = __webpack_require__(17);
	
	var _mixins2 = _interopRequireDefault(_mixins);
	
	var _theme = __webpack_require__(14);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Heading = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'VideoCallout__Heading'
	})(['margin:150px auto ', ';max-width:600px;h2{', ';}h3{', ';}'], _theme.sp.xxl, _mixins2.default.headingText, _mixins2.default.subheadingText);
	
	var VideoThumbnail = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'VideoCallout__VideoThumbnail'
	})(['position:relative;border-radius:8px;padding-bottom:56.25%;width:100%;height:0;']);
	
	var ModalVideoContainer = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'VideoCallout__ModalVideoContainer'
	})(['background:', ';position:relative;width:100%;height:0;padding-bottom:56.25%;iframe{position:absolute;top:0;left:0;width:100%;height:100%;}'], _theme.colors.black);
	
	var propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  subheading: _propTypes2.default.string.isRequired
	};
	
	var VideoCallout = function (_React$Component) {
	  _inherits(VideoCallout, _React$Component);
	
	  function VideoCallout() {
	    _classCallCheck(this, VideoCallout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  VideoCallout.prototype.componentWillMount = function componentWillMount() {
	    if (typeof document !== 'undefined') {
	      var script1 = document.createElement('script');
	      script1.src = '//fast.wistia.com/embed/medias/0k7dw0i29u.jsonp';
	      script1.async = true;
	      document.body.appendChild(script1);
	
	      var script2 = document.createElement('script');
	      script2.src = '//fast.wistia.com/assets/external/E-v1.js';
	      script2.async = true;
	      document.body.appendChild(script2);
	    }
	  };
	
	  VideoCallout.prototype.render = function render() {
	    var _props = this.props,
	        heading = _props.heading,
	        subheading = _props.subheading;
	
	    return _react2.default.createElement(
	      _shared.Container,
	      { centerText: true },
	      _react2.default.createElement(
	        Heading,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          heading
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          subheading
	        )
	      ),
	      _react2.default.createElement(
	        VideoThumbnail,
	        null,
	        _react2.default.createElement(
	          ModalVideoContainer,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'wistia_responsive_padding',
	              style: { padding: '56.25% 0 0 0', position: 'relative' }
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'wistia_responsive_wrapper',
	                style: {
	                  height: '100%',
	                  left: 0,
	                  position: 'absolute',
	                  top: 0,
	                  width: '100%'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'wistia_embed wistia_async_0k7dw0i29u seo=false videoFoam=true',
	                  style: { height: '100%', width: '100%' }
	                },
	                '\xA0'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return VideoCallout;
	}(_react2.default.Component);
	
	VideoCallout.propTypes = propTypes;
	
	exports.default = VideoCallout;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VideoCallout = __webpack_require__(416);
	
	var _VideoCallout2 = _interopRequireDefault(_VideoCallout);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _VideoCallout2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ServiceDetails = exports.VideoCallout = exports.Testimonials = exports.Hero = undefined;
	
	var _Hero = __webpack_require__(409);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Testimonials = __webpack_require__(415);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _VideoCallout = __webpack_require__(417);
	
	var _VideoCallout2 = _interopRequireDefault(_VideoCallout);
	
	var _ServiceDetails = __webpack_require__(412);
	
	var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Hero = _Hero2.default;
	exports.Testimonials = _Testimonials2.default;
	exports.VideoCallout = _VideoCallout2.default;
	exports.ServiceDetails = _ServiceDetails2.default;

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HomePage = __webpack_require__(407);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _HomePage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HowardThomas.adfd7030.png";

/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/North-America-Map.4b707494.png";

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ShaoYang.7ad4383d.png";

/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/biobelle-logo.d28f0ad3.png";

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HomePage = __webpack_require__(419);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  // eslint-disable-next-line react/forbid-prop-types
	  data: _propTypes2.default.any.isRequired
	};
	
	function HomePageContainer(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(_HomePage2.default, { data: data });
	}
	
	HomePageContainer.propTypes = propTypes;
	
	exports.default = HomePageContainer;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f1e9c9b85741b10c3c7e.js